module.exports = __webpack_public_path__ + "static/media/Rate.b9a8772d.svg";